import { configureStore } from "@reduxjs/toolkit";

import ui from "./slice/ui";
import lang from "./slice/lang";
import publicKeySlice from "./slice/publicKey";
import resourcesSlice from "./slice/resources";
import serverSettingSlice from "./slice/serverSetting";
import userSlice from "./slice/user";
import pageContextSlice from "./slice/pageContext";
import deviceModelSlice from "./slice/deviceModel";
import deviceSetting from "./slice/deviceSetting";
import supportSettingSlice from "./slice/supportSetting";
import noticeSlice from "./slice/notice";
import userProfileSlice from "./slice/userProfile";
import fetchStatusSlice from "./slice/fetchStatus";
import apiAccessSlice from "./slice/apiAccess";
import adminPageContextSlice from "./slice/adminPageContext";
import coTerminationSlice from "./slice/coTermination";

const store = configureStore({
  reducer: {
    ui: ui.reducer,
    lang: lang.reducer,
    publicKey: publicKeySlice.reducer,
    resources: resourcesSlice.reducer,
    serverSetting: serverSettingSlice.reducer,
    user: userSlice.reducer,
    userMyProfile: userProfileSlice.reducer,
    pageContext: pageContextSlice.reducer,
    adminPageContext: adminPageContextSlice.reducer,
    deviceModel: deviceModelSlice.reducer,
    deviceSetting: deviceSetting.reducer,
    supportSetting: supportSettingSlice.reducer,
    notice: noticeSlice.reducer,
    fetchStatus: fetchStatusSlice.reducer,
    apiAccess: apiAccessSlice.reducer,
    coTermination: coTerminationSlice.reducer,
  },
});

// Export store
export default store;
